export function initialize(): void {
    wireAnnotation();
    addEscapeKeyListener();
}

function wireAnnotation(): void {
    $('.annotation-link')
        //.on('mouseenter', showAnnotation)
        //.on('mouseleave', hideAnnotation)
        .on('click', toggleAnnotation)
        .each(function() {
            
            // Flytta href för att inte skriptet för mjukt scrollande internlänkar ska kicka in vid klick
            var $this = $(this);

            const target = $this.attr('href');
            const count = $this.text();
            const bTarget = $this.attr('href') as string;
            const $bTarget = $(bTarget);

            $this.data('target', target);
            $this.attr('href', '#');

            addBackButton($bTarget, bTarget, count);
            $bTarget.css('counter-set', `annotations ${count}`)
        });

    $('.toggleShowannotations')
        .on('change', toggleAnnotations)

    $(document).on('click', (e: JQuery.ClickEvent) => {
        const $visible = $('.annotation-text.annotation-text--visible');

        if (
            !$visible.is(e.target as Element) &&
            $visible.has(e.target as Element).length === 0
        ) {
            closeAllAnnotations();
            $('.annotation-link.annotation-link--opened').focus();
            $('.annotation-link').removeClass('annotation-link--opened').removeClass('annotation-link--selected');
        }
    });

    $(document).on('click', '.annotation-close', function (e) {
        e.stopPropagation();

        closeAllAnnotations();
        $('.annotation-link.annotation-link--opened').focus();
        $('.annotation-link').removeClass('annotation-link--opened').removeClass('annotation-link--selected');
        $('.annotation-text--cloned').remove();

        removeCloseButton();
    });

    $(document).on('click', '.annotation-scroll', function (e) {
        e.stopPropagation();

        const $this = $(this);
        const targetSelector = $this.data('target') as string;
        const $target = $(targetSelector);
        $('.annotation-text').removeClass('annotation-text--visible').removeAttr('tabindex'); 

        scrollToAnnotation($target);

        closeAllAnnotations();
        $('.annotation-link').removeClass('annotation-link--opened');
        $target.attr('tabindex', '-1').addClass('annotation-text--visible').focus();
    });

    $(document).on('click', '.annotation-back', function (e) {
        e.stopPropagation();

        const targetSelector = $(this).data('target') as string;

        const $link = $(`.annotation-link`).filter(function () {
            return $(this).data('target') === targetSelector;
        });

        scrollToAnnotation($link);
        $('.annotation-link.annotation-link--selected').removeClass('annotation-link--selected');
        //$($this).remove();
    });
}
function showAnnotation() {
    var $this = $(this);
    var target = $this.data('target');
    var $target = $(target);

    $this.toggleClass('annotation-link--opened annotation-link--selected');

    if ($target.hasClass('annotation-text--locked')) {
        closeAllAnnotations();

        const $clone = $('<div class="annotation-text annotation-text--hover annotation-text--cloned"></div>');

        $clone.html($target.html());

        $clone.insertBefore($target);

        placeAnootation($this, $clone);
    } else {
        $('.annotation-text').not($target).removeClass('annotation-text--visible');
        placeAnootation($this, $target);
        $target.addClass('annotation-text--hover');
    }
}

function hideAnnotation() {
    var $this = $(this);
    var target = $this.data('target');
    var $target = $(target);

    $('.annotation-text').removeClass('annotation-text--hover'); 
    $('.annotation-link').removeClass('annotation-link--opened');
    $target.removeClass('annotation-text--hover');
}
function toggleAnnotations() {
    if(this.checked) {
        $('.annotation-text').addClass('annotation-text--locked');
        return;
    }

    $('.annotation-text').removeClass('annotation-text--locked');
}

function toggleAnnotation(e: JQuery.ClickEvent): void {
    e.stopPropagation();

    const $from = $(this);
    const $this = $(e.currentTarget);
    const target = $this.data('target') as string;
    const $target = $(target);

    $this.toggleClass('annotation-link--opened annotation-link--selected');

    if ($target.hasClass('annotation-text--locked')) {
        closeAllAnnotations();

        if ($this.hasClass('annotation-link--opened')) { 
            const $clone = $('<div class="annotation-text annotation-text--visible annotation-text--cloned"></div>');

            $clone.html($target.html());

            $clone.insertAfter($from);

            addCloseButton($clone);
            addScrollLink($this, $clone, target);

            placeAnootation($this, $clone);

            if ($this.hasClass('annotation-link--opened')) {
                $clone.focus();
            } else {
                $this.focus();
            }
        }
    } else { 
        $('.annotation-text').not($target).removeClass('annotation-text--visible');
        addCloseButton($target);
        addScrollLink($this, $target, target);
        placeAnootation($this, $target);

        $target.toggleClass('annotation-text--visible');

        if ($this.hasClass('annotation-link--visible')) {
            $target.focus();
        } else {
            $this.focus();
        }
    }
}

function placeAnootation($this: JQuery<HTMLElement>, $target: JQuery<HTMLElement>) {
    const screenWidth = $(window).width() ?? 0;
    const docWidth = $("#documentcontent-main").width() ?? 0;
    var offset = ($this.position());
    const targetWidth = $target.width() ?? 0;
    var targetHeight = $target.outerHeight() ?? 0;
    targetHeight = targetHeight + 66 + 36;
    $target.removeClass('annotation-text--right annotation-text--right annotation-text--to-left annotation-text--to-right');

    if (docWidth < 540 || (docWidth > 540 && screenWidth < 900)) {

        if (offset.left < 50) {
            $target.addClass('annotation-text--to-left');
            const maxWidth = docWidth - 42;
            $target.css({ top: offset.top - targetHeight, left: 0, maxWidth: maxWidth + "px", minWidth: maxWidth + "px" });

            requestAnimationFrame(() => {
                var targetHeightAfter = $target.outerHeight() ?? 0;
                targetHeightAfter = targetHeightAfter + 20;

                $target.css({
                    top: offset.top - targetHeightAfter
                });
            });

        } else if (docWidth - offset.left < 50) {
            $target.addClass('annotation-text--to-right');
            const maxWidth = docWidth - 42;
            $target.css({ left: 0, maxWidth: maxWidth + "px", minWidth: maxWidth + "px" });

            requestAnimationFrame(() => {
                var targetHeightAfter = $target.outerHeight() ?? 0;
                targetHeightAfter = targetHeightAfter + 20;

                $target.css({
                    top: offset.top - targetHeightAfter
                });
            });

        } else {
            if (offset.left > ((docWidth / 2) - 10)) {
                $target.addClass('annotation-text--right');
                const left = offset.left - 50;
                const maxWidth = left + 20;
                $target.css({ left: 50, maxWidth: maxWidth + "px", minWidth: maxWidth + "px" });

                requestAnimationFrame(() => {
                    var targetHeightAfter = $target.outerHeight() ?? 0;
                    targetHeightAfter = targetHeightAfter + 20;

                    $target.css({
                        top: offset.top - targetHeightAfter
                    });
                });

            } else {
                $target.addClass('annotation-text--left');
                const maxWidth = (docWidth - offset.left) - 10;
                $target.css({ left: offset.left - 50, maxWidth: maxWidth + "px", minWidth: maxWidth + "px" });

                requestAnimationFrame(() => {
                    var targetHeightAfter = $target.outerHeight() ?? 0;
                    targetHeightAfter = targetHeightAfter + 20;

                    $target.css({
                        top: offset.top - targetHeightAfter
                    });
                });
            }
        }
    } else {
        $target.css({ top: offset.top - $target.height() - 90, left: offset.left - 50 });
    }
}

function addEscapeKeyListener() {
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeAllAnnotations();
            $('.annotation-link.annotation-link--opened').focus();
            $('.annotation-link').removeClass('annotation-link--opened').removeClass('annotation-link--selected');
        }
    });
}
function closeAllAnnotations() {
    $('.annotation-text').removeClass('annotation-text--visible');
    $('.annotation-text--cloned').remove();

    const container = document.querySelector("#documentcontent-main");

    if (!container) return;

    const links = container.querySelectorAll("a[href]");

    links.forEach(a => {
        if (a.classList.contains('annotation-link')) {
            a.setAttribute('aria-label', 'Öppna not ' + a.textContent.trim());
        }
    });
}

function addCloseButton($target: JQuery): void {
    if ($target.find('.annotation-close').length) return;

    const $btn = $(`
        <button type="button" class="annotation-close" aria-label="Stäng">
            ×
        </button>
    `);

    $target.append($btn);
}

function removeCloseButton(): void {
    $('.annotation-close').remove();
}

function scrollToAnnotation($target: JQuery): void {
    const position =
        $target.offset()!.top -
        $('.header').outerHeight()! -
        $('#documentHeader').outerHeight()!;

    $('html, body').animate({ scrollTop: position }, 500);
}

function addScrollLink(thisLink, $target: JQuery, targetId): void {
    if ($target.find('.annotation-scroll').length) return;

    thisLink.addClass("annotation-link--selected");

    const $link = $(`
        <a href="#" 
            class="annotation-scroll"
            data-target="${targetId}">
            Gå till noten i texten
        </a>
    `);

    $target.append($link);
}

function addBackButton($target: JQuery, targetSelector: string, count: string): void {
    if ($target.find('.annotation-back').length) return;

    const $btn = $(`
        <span class="annotation-count"><a href="#"
            class="annotation-back"
            data-target="${targetSelector}">
            Not ${count}
        </a></span>
    `);

    const $firstP = $target.find('p').first();

    if ($firstP.length) {
        $firstP.prepend($btn); // 👈 först i första p
    } else {
        $target.prepend($btn); // fallback om ingen p finns
    }
}